import {
  Box,
  Button,
  Grid2 as Grid,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Colors from '../../../utils/colors.json'
import { useState } from 'react'

const styles = () => ({
  nameBox: {
    padding: 3,
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
  },
  relationBox: {
    padding: 3,
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '30%',
  },
  copaySelect: {
    borderRadius: '20px',
    fontSize: '13px',
  },
  copayText: {
    fontSize: '14px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  copayTextSecondary: {
    fontSize: '16px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  radioLabel: {
    fontSize: '13px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  actionBtn: {
    borderRadius: '20px',
    textTransform: 'capitalize',
    minWidth: '180px',
  },
})

const ApproveReject = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // eslint-disable-next-line
  const [copayData, setCopayData] = useState([
    {
      relation: 'self',
      name: 'vinod',
      age: 28,
      copay: 65,
    },
    {
      relation: 'Mother',
      name: 'Geetha',
      age: 45,
      copay: 75,
    },
    {
      relation: 'Father',
      name: 'Ramakrishna',
      age: 64,
      copay: 95,
    },
  ])

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      width={'100%'}
      gap={3}
      mt={1}
    >
      {copayData?.map((item, index) => (
        <Grid container direction={'row'} spacing={2} key={index}>
          <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
            <Box
              display={'flex'}
              justifyContent={'start'}
              alignItems={'center'}
              gap={3}
              width={'100%'}
            >
              <Typography className={classes?.copayText}>Member</Typography>
              <Typography className={classes?.relationBox}>
                {item?.relation}
              </Typography>
              <Typography className={classes?.nameBox}>
                {item?.name},
                <span className={classes?.copayText}>{item?.age} Years</span>
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              gap={3}
            >
              <Typography className={classes?.copayTextSecondary}>
                Select Discount
              </Typography>
              <Select
                value={item?.copay}
                size='small'
                className={classes?.copaySelect}
              >
                <MenuItem value={65}>65%</MenuItem>
                <MenuItem value={75}>75%</MenuItem>
                <MenuItem value={95}>95%</MenuItem>
              </Select>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue='female'
                  name='radio-buttons-group'
                >
                  <FormControlLabel
                    value='approve'
                    control={<Radio />}
                    label={
                      <Typography className={classes?.radioLabel}>
                        Approve
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value='revise'
                    control={<Radio />}
                    label={
                      <Typography className={classes?.radioLabel}>
                        Revise
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value='reject'
                    control={<Radio />}
                    label={
                      <Typography className={classes?.radioLabel}>
                        Reject
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      ))}
      <Box display={'flex'} justifyContent={'center'}>
        <Button
          variant='contained'
          color='primary'
          className={classes?.actionBtn}
        >
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default ApproveReject
